import { Component, OnInit } from '@angular/core';

//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';

// import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { quickPayModel } from '../../models/quickpay/quickpay.model';
import { AppSettings } from '../../config/settings/app-settings';
import { IMyDpOptions } from 'mydatepicker';
import{ AppComponent} from '../../app.component';
import * as jsPDF from 'jspdf';
import * as $ from 'jquery';
import { Constants } from 'app/config/settings/constants';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-request-manage',
	templateUrl: './mybills.component.html',
	styleUrls: ['./mybills.component.css']
})
export class mybillsComponent implements OnInit {

	noBill: boolean = false;
	//variable deceleration
	//   @BlockUI() blockUI: NgBlockUI;
	public isHt: boolean = false;
	public errorMsg: string = "";
	public successMsg: string = "";
	public sessionData: any;
	public allBillData: any = "";
	public allCategoryData: any = [];
	public allSubData: any = [];
	public quickPayModel: quickPayModel = new quickPayModel;
	public isTermsCond: boolean = true;
	public popupopen: boolean = false;
	public viewpopupopen: boolean = false;
	public serviceOn: boolean = false;
	public pdfSaving: boolean = false;
	public viewStatus: string = "";
	public viewDate: any = "";
	public viewDocket: any = "";
	public viewCat: any = "";
	public viewSubCat: any = "";
	public viewDetails: string = "";
	public UserBillData: any = "";
	public monthArr: any = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
	public payableData: any = "";
	public captchaView: string = "";
	public registeredUserData: any = "";
	public billFetched: boolean = false;
	public checkSumData: any = "";
	public barCodeValue: string = "";
	public consumerNoAndDate: string = "";
	public fileDetails: any;
	public disableButton: boolean = true;
	public isDisableCB: boolean = true;
	public isChecked: boolean = false;
	public isShowTermsCondnts: boolean = false;
	public isHideMyBillsAmount: boolean = false;
	public isHideMyBillButton: boolean = false;
	public payableAmount: number;


	public barChartOptions: any = {
		scaleShowVerticalLines: false,
		responsive: true
	};
	public barChartLabels: any = [];
	public barChartType: string = 'bar';
	public barChartdoughnutChartType: string = 'doughnut';
	public barChartLegend: boolean = true;

	public barChartData: any[] = [
		{ data: [], label: 'Bill Amount' }
	];

	public barChartDatadoughnut: any = []

	public myDatePickerOptions: IMyDpOptions = {
		// other options...
		dateFormat: 'dd/mm/yyyy',
		disableUntil: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() - 1 }
	};

	getBillDetailsBlocked: boolean = false;
	pdfGenerateBlocked: boolean = false;
	msgToShowWhileDownloadFile: string = Constants.msgToShowWhileDownloadFile;

	constructor(public http: HttpTestService, 
				public session: sessionServices,
				private appComponent: AppComponent,
				private actvRoute : ActivatedRoute ) { }

	ngOnInit() {
		
		//this.quickPayModel.paymentOpt = "BILLDESK";
		this.isDisableCB = true;
		this.getSession();
		// this.getAsansolBillDetails();
		//-------Code snippet for chatbot purpose only---------//		
		let consumerId = this.actvRoute.snapshot.paramMap.get('consumerId') ;		
		if(consumerId) this.quickPayModel.consumerId = consumerId;
		
		//------------------------------------//

	}


	//get session details
	getSession = function () {
		this.serviceOn = true;
		this.sessionData = this.session.getSessionDetails();

		if (!this.sessionData.consumerId || this.sessionData.consumerId == '' || this.sessionData.consumerId == undefined) {
			this.generateCaptcha();
			console.log("No session found... IF");
		} else {
			this.getBillHistory();
			this.getConsumerDetails();
			console.log("Session found... ELSE");
		}
		this.serviceOn = false;
	}


	randomString = function (len, an) {
		an = an && an.toLowerCase();
		var str = "", i = 0, min = an == "a" ? 10 : 0, max = an == "n" ? 10 : 62;
		for (; i++ < len;) {
			var r = Math.random() * (max - min) + min << 0;
			str += String.fromCharCode(r += r > 9 ? r < 36 ? 55 : 61 : 48);
		}
		return str;
	}
	showTermsCondtn() {
		if (this.isChecked) {
			this.disableButton = true;
			this.isShowTermsCondnts = false;
		} else {
			this.disableButton = false;
			this.isShowTermsCondnts = true;
		}

	}

	openTermsCondition() {
		this.isTermsCond = false;
	}

	cancelTermsCondtn() {
		this.isTermsCond = true;
	}

	valueChange(value) {
		if (value == "BILLDESK" || value == "RAZORPAY") {
			this.disableButton = true
			this.isDisableCB = false;
			if (this.isChecked === true)
				this.isChecked = false;
		} else {
			this.isDisableCB = true;
			if (this.isChecked === true)
				this.isChecked = false;
		}
	}

	generateCaptcha = function () {
		var self = this;
		var cap = self.randomString(3);
		self.captchaView = cap;
	}


	//get consumer details
	getConsumerDetails = function (e) {
		var self = this;
		if (self.serviceOn === false)
			self.serviceOn = true;
		self.otpSend = false;
		self.errorMsg = "";
		self.successMsg = "";
		self.quickPayModel.consumerOtp = "";
		var requestedConsumer = (self.sessionData.sessionStarted == "true") ? self.sessionData.sessionId : self.quickPayModel.consumerId;

		// this.allBillData =[];
		// this.payableData ='gdfgddgdgd';
		// self.sessionData.consumerId = undefined;
		var consumerNo = requestedConsumer ;//self.quickPayModel.consumerId;
		/* added to filter specific consumer id list to be restricted; instruction from Sandip Saha on 03.02.2020 */
		if(this.sessionData.sessionStarted != 'true') {
			let numericConsumerNo: number = parseInt(consumerNo);
			if(Constants.restrictedConsumerList.indexOf(numericConsumerNo) > -1) {
				this.errorMsg = "Please login to view bill details!";
				this.allUserData = "";
				this.serviceOn = false;
				return;
			}
		}
		//alert(consumerNo);
		self.http.getAsansolBill(consumerNo)
			.subscribe(
				(data) => {
					self.UserBillData = data;
					self.payableAmount = parseInt(self.UserBillData.amount);
				},
				(error) => {
					//self.errorMsg = error;
					self.UserBillData = "";
				},
				() => {
				}
			);

		self.http.getUserDetailsByConsNo(requestedConsumer)
			.subscribe(
				(data) => {
					self.registeredUserData = data;
					if (self.registeredUserData.status === "GAYACONSUMERID") {
						self.errorMsg = "Service is not available for this number range";
						self.registeredUserData = "";
					}else if(self.registeredUserData.status === "fail"){
						self.errorMsg = data.status;
						self.errorMsg = "Invalid Comsumer Id";
						self.serviceOn = false;
					} else {
						if (self.registeredUserData != null) {
							this.appComponent.getBroadCastForMyConsumption(self.registeredUserData.region, self.registeredUserData.businessAreaText)//"Asansol-DPS", "Gopalpur"
							self.getBillHistory();
							this.getPayableAmount();
						}
					}
				},
				(error) => {
					//self.errorMsg = error;
					self.registeredUserData = "";
				},
				() => {
					//self.serviceOn = false;
					if (self.registeredUserData.name.trim() === '') {
						this.consumerNO = self.registeredUserData.consumerNo;
						self.registeredUserData = "";
						self.errorMsg = "Provided Consumer No is not Valid !";
						self.payData = '';
						self.isHideMyBillsAmount = true;
						self.isHideMyBillButton = true;
						self.sessionData.consumerId = undefined;
						self.allBillData = null;
						self.payableData = '';
					}
				}
			);
		if (self.serviceOn === true)
			self.serviceOn = false;
	}


	getBillHistory = function () {

		var self = this;
		if (self.serviceOn === false)
			self.serviceOn = true;
		self.billFetched = true;
		var today: any = new Date();
		var todayDD: any = today.getDate();
		var todayMM: any = today.getMonth() + 1;

		var todayYYYY: any = today.getFullYear();
		var tillDate: any = today.setDate(today.getDate() - 180);
		var tillDateDD: any = new Date(tillDate).getDate();
		var tillDateMM: any = new Date(tillDate).getMonth() + 1;
		var tillDateYYYY: any = new Date(tillDate).getFullYear();

		if (todayMM < 10) { todayMM = "0" + todayMM }
		if (tillDateDD < 10) { tillDateDD = "0" + tillDateDD }
		if (todayDD < 10) { todayDD = "0" + todayDD }
		if (tillDateMM < 10) { tillDateMM = "0" + tillDateMM }
		if (!self.sessionData.consumerId || self.sessionData.consumerId == '' || self.sessionData.consumerId == undefined) {
			var requestedParams: any = self.quickPayModel.consumerId + "^" + todayYYYY + "-" + todayMM + "-" + todayDD + "^" + tillDateYYYY + "-" + tillDateMM + "-" + tillDateDD;//"2010265374^2018-03-31^2018-01-01"
			var requestedRegeon: any = self.registeredUserData.region;
		} else {
			var requestedParams: any = self.sessionData.consumerId + "^" + todayYYYY + "-" + todayMM + "-" + todayDD + "^" + tillDateYYYY + "-" + tillDateMM + "-" + tillDateDD;//"2010265374^2018-03-31^2018-01-01"
			var requestedRegeon: any = self.sessionData.sessionRegion;
		}

		if ((requestedRegeon).startsWith("GAYA")) {
			self.http.getGayaBillHistory(requestedParams)
				.subscribe(
					(data) => {
						self.allBillData = data.billParam;
					},
					(error) => {
						//self.errorMsg = error;
						self.allBillData = "";
					},
					() => {

						if (self.allBillData != "") {
							self.allBillData = (self.allBillData).split(" | ");
						}
						var billData = [];
						self.barChartLabels = [];
						for (var i = 0; i < self.allBillData.length; i++) {
							self.barChartLabels.push((self.allBillData[i]).split(" ")[1]);
							billData.push((self.allBillData[i]).split(" ")[2]);
						}

						self.barChartData[0].data = billData;
						self.barChartDatadoughnut = billData;

					}
				);
		} else {
			//alert("Asansol Bill History");
			self.http.getAsanBillHistory(requestedParams)
				.subscribe(
					(data) => {

						if(data.status === "NORESPONSEFROMSAP") {
							self.status = data.status;
							self.errorMsg = "Your last 6 months bill history is not available !";
							self.serviceOn = false;
							this.noBill = false;
						}else{
							 self.allBillData = data.billParam;
							 if(self.allBillData == null || self.allBillData == ''){
								this.noBill = false;
							 }else{
								this.noBill = true;
							 }
						}
					},
					(error) => {
						//self.errorMsg = error;
						self.allBillData = "";
					},
					() => {

						if (self.allBillData != "") {
							self.allBillData = (self.allBillData).split(" | ");
						}
						var billData = [];
						for (var i = 0; i < self.allBillData.length; i++) {
							self.barChartLabels.push((self.allBillData[i]).split(" ")[1]);
							billData.push((self.allBillData[i]).split(" ")[2]);
						}
						self.barChartData[0].data = billData;
						self.barChartDatadoughnut = billData;

					}
				);
		}
		if (self.serviceOn === true)
			self.serviceOn = false;
	}


	getPayableAmount = function () {
		var self = this;
		if (!this.sessionData.consumerId || this.sessionData.consumerId == '' || this.sessionData.consumerId == undefined) {
			var reqId = self.quickPayModel.consumerId;
		} else {
			var reqId = self.sessionData.consumerId;
		}


		self.http.getPayableAmount(reqId)
			.subscribe(
				(data: any) => {
					self.payableData = data;
					self.UserBillData = data;
					self.payableAmount = parseInt(self.UserBillData.amount);
				},
				(error) => {
					//self.errorMsg = error;
					self.payableData = "";
				},
				() => {
				}
			);
	}

	getBillDetails = function (index) {

		var self = this;
		self.serviceOn = true;
		var date = (self.allBillData[index]).split(" ")[1];

		if (self.quickPayModel.consumerId != null && self.quickPayModel.consumerId != "") {
			self.consumerNo = self.quickPayModel.consumerId;
			//alert("consumerNo"+self.consumerNo );
		} else {
			self.consumerNo = self.sessionData.consumerId;
			//	alert("self.consumerNo"+self.consumerNo);
		}




		// self.consumerNo = self.sessionData.consumerId;
		// self.consumerNo = self.quickPayModel.consumerId;


		self.consumerNoAndDate = date + ',' + self.consumerNo
		//alert("Consumer Id : "+self.consumerNoAndDate);
		self.http.createAndDownloadBillPdf(self.consumerNoAndDate).subscribe(
			(success: any) => {

			}, error => {
				self.errorMsgs = "Error in Invoice Pdf file creation !";
				if (error.error.text == "success") {
					//alert("Consumer  No with date: "+this.consumerNoAndDate)
					self.http.downloadBillDocument(this.consumerNoAndDate).subscribe(
						downloadSuccess => {
							const blob = downloadSuccess.blob();
							const file = new Blob([blob], {});
							var fileURL = URL.createObjectURL(blob);

							let newWindow = window.open(fileURL);
							if(!newWindow || newWindow.closed || typeof newWindow.closed=='undefined') { 
								this.getBillDetailsBlocked = true;
								setTimeout(() => { this.getBillDetailsBlocked = false; }, 3000);
							}
							
							self.serviceOn = false;
						}).then(
							resolve => {
								alert("Invoice Bill downloded Successfully !")
							},
							reject => {
								self.errorMsg = "Error in downloding the PDF";
							});
				}
			});

	}







	// getBillDetails = function(index){
	// //	alert("OK")
	// 	var self = this;
	// 	self.serviceOn = true;
	// 	self.barCodeValue = "";
	// 	if(!this.sessionData.consumerId || this.sessionData.consumerId == '' || this.sessionData.consumerId == undefined){
	// 	var requestedRegeon : any = self.registeredUserData.region;
	// }else{
	// 	var requestedRegeon : any = self.sessionData.sessionRegion;
	// }
	// 	var reqId = (self.allBillData[index]).split(" ")[0];
	// 	if((self.registeredUserData.tariff).startsWith("HTS")){
	// 		self.isHt = true;
	// 		if((self.registeredUserData.region).startsWith("GAYA")){
	// 	self.http.getHTGayaBill(self.payableData.lastDocno)
	// 		.subscribe(
	// 		(data) => {
	// 			self.UserBillData = data;
	// 			 },
	// 		(error) => {
	// 			self.errorMsg = error;
	// 			self.UserBillData = "";
	// 		},
	// 		() => {
	// 			self.popupopen = true;
	// 			self.serviceOn = false;
	// 		}
	// 		);
	// 	}
	// 	}else{

	// 	if((requestedRegeon).startsWith("GAYA")){
	// 	self.http.getGayaBill(reqId)//self.payableData.docNo
	// 		.subscribe(
	// 		(data) => {
	// 			self.UserBillData = data;
	// 			 },
	// 		(error) => {
	// 			self.errorMsg = error;
	// 			self.UserBillData = "";
	// 		},
	// 		() => {
	// 			var dudt = ((self.UserBillData.billParam4).split("|"))[3];
	// 			var dd = dudt.split("-")[0];
	// 			var mm = self.monthArr.indexOf(dudt.split("-")[1]) + 1;
	// 			if(mm < 10){mm = "0"+mm};
	// 			if(dd < 10){dd = "0"+dd};
	// 			var yyyy = dudt.split("-")[2];
	// 			var cutoff = new Date(mm+"/"+dd+"/"+yyyy);//markDate
	// 			var previewCutoff = cutoff.setDate(cutoff.getDate() + 10);
	// 			self.markDate = new Date(previewCutoff).getDate()+"-"+self.monthArr[new Date(previewCutoff).getMonth()]+"-"+new Date(previewCutoff).getFullYear();
	// 			self.popupopen = true;
	// 			self.serviceOn = false;
	// 			self.barCodeValue = 'X'+((self.UserBillData.billParam4).split("|"))[1];
	// 		}
	// 		);
	// 	}else{
	// 		self.http.getAsansolBill(reqId)
	// 		.subscribe(
	// 		(data) => {
	// 			self.UserBillData = data;
	// 			 },
	// 		(error) => {
	// 			self.errorMsg = error;
	// 			self.UserBillData = "";
	// 		},
	// 		() => {
	// 			self.serviceOn = false;
	// 		}
	// 		);
	// 	}
	// 	}

	// }




	closePopup = function () {
		var self = this;
		self.popupopen = false;
		self.UserBillData = "";
		self.billFetched = false;
		self.barCodeValue = "";
		self.isHt = false;
	}

	closePopupFull = function () {
		var self = this;
		self.popupopen = false;
		self.UserBillData = "";
		self.allBillData = "";
		self.payableData = "";
		self.billFetched = false;
		self.generateCaptcha();
		self.quickPayModel.consumerId = "";
		self.quickPayModel.reEnterCaptcha = "";
		self.barCodeValue = "";
		self.isHt = false;
	}


	// pdfGenerate = function(){
	// 	var doc = new jsPDF('p', 'mm', 'a4');
	// 	doc.internal.scaleFactor = 5;
	// 	doc.addHTML($('#userBill'),30,6, {pagesplit: true, background:"#ffffff"}, function () { doc.save('Bill.pdf');})

	// 	// Save the PDF
	// 	//doc.save('Test.pdf');
	// }

	pdfGenerate = function () {
		var self = this;
		self.consumerNo = self.quickPayModel.consumerId;
		self.http.createAndDownloadPdf(self.consumerNo).subscribe(
			success => {

			}, error => {
				self.errorMsgs = "Error in Invoice Pdf file creation !";
				if (error.error.text == "success") {
					self.http.downloadDocument(this.consumerNo).subscribe(
						downloadSuccess => {
							const blob = downloadSuccess.blob();
							const file = new Blob([blob], {});
							var fileURL = URL.createObjectURL(blob);
							
							let newWindow = window.open(fileURL);
							if(!newWindow || newWindow.closed || typeof newWindow.closed=='undefined') { 
								this.pdfGenerateBlocked = true;
								setTimeout(() => { this.pdfGenerateBlocked = false; }, 3000);
							}
						}).then(
							resolve => {
								alert("Invoice Bill downloded Successfully !")
							},
							reject => {
								self.errorMsg = "Error in downloding the PDF";
							});
				}
			});
	}

	choosePayOpt = function () {
		var self = this;
		self.isChecked = false;
		self.viewpopupopen = true;

	}

	startPayment = function () {
		var self = this;
		if (self.quickPayModel.paymentOpt == "BILLDESK") {
			self.billDeskPayment();
		}else if (self.quickPayModel.paymentOpt == "RAZORPAY") {
			self.payWithRazorpayGateway();
		} else if (self.quickPayModel.paymentOpt == "PAYTM") {
			self.paytmPayment();
		}
	}

	payWithRazorpayGateway() {
		let consumerNo: any;
		if (this.quickPayModel.consumerId != null && this.quickPayModel.consumerId != "") {
			consumerNo = this.quickPayModel.consumerId;
			//alert("consumerNo"+self.consumerNo );
		} else {
			consumerNo = this.sessionData.consumerId;
			//	alert("self.consumerNo"+self.consumerNo);
		}

		// this.billAmount = 100; // TODO: remove beore production
		var paymentType = 4;
		var payChannelId = 1;
		this.postPaymentData.consumerId = consumerNo;
		this.postPaymentData.paymentType = paymentType;
		this.postPaymentData.amount = this.payableData.amount;
		this.postPaymentData.gateway = 2;
		this.postPaymentData.paymentChannelId = payChannelId;

		if(!this.postPaymentData.amount || this.postPaymentData.amount < 1) {
			this.errorMsg = 'Can not proceed with bill amount zero(0).';
			return false;
		}

		// initiate payment request
		this.http.postPayEmd(this.postPaymentData).subscribe((data) => {
			if(data['orderNo'] == null) { this.errorMsg = 'Could not proceed with gateway, please try again later.'; return; }
			let orderNo: String = data['orderNo'];
			if(orderNo && orderNo.length > 0) {
				let options: any = {
					"key": Constants.rzp_key,
					"amount": (this.postPaymentData.amount * 100), /* amount to be passed as lowest currency unit */
					"name": "INDIA POWER",
					"description": "Payment",
					"image": "./assets/images/logo.jpg",
					"order_id": orderNo,
					"modal": {
						"escape": false
					},
					"prefill": {
						// "name": this.postPaymentData.consumerId,
						// "email": "gaurav.kumar@example.com",
						// "contact": "9999999999",
						// "method": 'card',
						// 'card[number]': finalObj.cardDetail.cardNumber,
						// 'card[expiry]': finalObj.cardDetail.cardExpDate,
						// 'card[cvv]': finalObj.cardDetail.cardCvv
					},
					"notes": {
					  "Consumer_Id": this.postPaymentData.consumerId
					},
					// "theme": {
					// 	"color": "#0d4371"
					// }
				};
				options.handler = ((response) => {
					options['payment_response_id'] = response.razorpay_payment_id;
					this.handleRazorpayResponse(response);
				});
				options.modal.ondismiss = (() => {
					//   this.loginService.SetLoader = false;
				});
				let rzp = new this.http.nativeWindow.Razorpay(options);
				rzp.open();
			} else {
				this.errorMsg = 'Order could not be created, please try again later.';
			}

		}, (error) => {
			this.errorMsg = error;
		}, () => {
			this.successMsg = "";
			this.serviceOn = false;
		});
		
	}

	handleRazorpayResponse(razorpayResponse) {
		this.http.postRazorpayResponse(razorpayResponse).subscribe((resp) => {
			if(resp['status'] === 'success') {
				this.successMsg = resp['paymentProcessingMessage'];
				setTimeout(() => { window.location.reload(); }, 5000);
			} else {
				this.errorMsg = resp['paymentProcessingMessage'];
			}
		});
	}

	paytmPayment = function () {
		var self = this;
		window.location.href = AppSettings.PAYTM_URL;
	}

	public postPaymentData = {
		"applicationNumber": null,
		"paymentType": null,
		"amount": null,
		"consumerId": null,
		"paymentChannelId": null,
		"gateway": null,
	}





	billDeskPayment = function () {
		// 	var self = this;
		// 	var requestedMob = (self.registeredUserData.mobile == null || self.registeredUserData.mobile == undefined || self.registeredUserData.mobile == '')?'NA':self.registeredUserData.mobile;
		// 	var timestamp = new Date().getTime();
		// 	var createdMsgStrngchcksum = AppSettings.BILLDESK_MARCH+"%7C"+((self.registeredUserData == "")?self.sessionData.consumerId:self.quickPayModel.consumerId)+timestamp+"%7CNA%7C"+self.payableData.amount+"%7CNA%7CNA%7CNA%7CINR%7CNA%7CR%7C"+AppSettings.BILLDESK_SEC+"%7CNA%7CNA%7CF%7CNA%7CNA%7CNA%7CNA%7C"+((self.registeredUserData == "")?self.sessionData.consumerId:self.quickPayModel.consumerId)+"%7C"+requestedMob+"%7C"+self.payableData.lastDocno+timestamp+"%7Chttp:fwdSlashfwdSlash13.126.3.149:9191fwdSlashpaymentfwdSlashpayment.jsp";
		// 	var createdMsgStrng = AppSettings.BILLDESK_MARCH+"%7C"+((self.registeredUserData == "")?self.sessionData.consumerId:self.quickPayModel.consumerId)+timestamp+"%7CNA%7C"+self.payableData.amount+"%7CNA%7CNA%7CNA%7CINR%7CNA%7CR%7C"+AppSettings.BILLDESK_SEC+"%7CNA%7CNA%7CF%7CNA%7CNA%7CNA%7CNA%7C"+((self.registeredUserData == "")?self.sessionData.consumerId:self.quickPayModel.consumerId)+"%7C"+requestedMob+"%7C"+self.payableData.lastDocno+timestamp+"%7Chttp://13.126.3.149:9191/payment/payment.jsp";
		// 	self.http.getChecksum(createdMsgStrngchcksum)
		// 	  .subscribe(
		// 		(data) => {
		// 		  self.checkSumData = data;
		// 		  },
		// 		(error) => {
		// 			self.errorMsg = error;
		// 			self.checkSumData = "";
		// 		},
		// 		() => {
		// 			window.location.href = AppSettings.BILLDESK_URL+"?msg="+createdMsgStrng+"%7C"+self.checkSumData.value;

		// 		}
		// );


		var self = this;
		if (self.quickPayModel.consumerId != null && self.quickPayModel.consumerId != "") {
			self.consumerNo = self.quickPayModel.consumerId;
			//alert("consumerNo"+self.consumerNo );
		} else {
			self.consumerNo = self.sessionData.consumerId;
			//	alert("self.consumerNo"+self.consumerNo);
		}

		//self.consumerId = self.quickPayModel.consumerId;
		var timestamp = new Date().getTime();
		var paymentType = 4;
		var payChannelId = 1;
		self.postPaymentData.consumerId = self.consumerNo;
		self.postPaymentData.paymentType = paymentType;
		//self.postPaymentData.amount = 0
		self.postPaymentData.amount = self.payableData.amount;
		self.postPaymentData.paymentChannelId = payChannelId;

		if(!this.postPaymentData.amount || this.postPaymentData.amount < 1) {
			//alert('amount 0')
			this.errorMsg = 'Can not proceed with bill amount zero(0).';
			return false;
		}
		
		if(this.postPaymentData.amount >= 500000) {
			this.errorMsg = 'Can not proceed with bill amount >= 500000.';
			return false;
		}

		self.http.postPayEmd(self.postPaymentData)
			.subscribe(
				(data) => {

					if(data && data.sourceSystem && data.sourceSystem.length > 20) {
						self.initiatePaymentData = data.sourceSystem;
						window.location.href = AppSettings.BILLDESK_URL + "?msg=" + self.initiatePaymentData;
					} else {
						self.errorMsg = "Unable to proceed payment!";
					}

				},
				(error) => {
					//self.errorMsg = error;
				},
				() => {

					self.successMsg = "";
					self.serviceOn = false;
				}
			)
	}

	cancelPayment = function () {
		var self = this;
		self.viewpopupopen = false;
	}

	clearBroadCastDataForBillHistoryLogin(){
		this.appComponent.getBroadCastForMyConsumption(null,null);
	}
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/mybills/mybills.component.ts